import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import ajax from '@/utils/ajax';

export interface Jurisdiction {
  id: string;
  name: string;
  active_on: string;
  status: string;
}

export const jurisdictionRepository = {
  async getJurisdictions({ host }: { host: string }): Promise<Jurisdiction[]> {
    const response = await ajax.get({
      url: `${host}/api/jurisdictions/`
    });

    return response.data;
  }
};

const JurisdictionRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getJurisdictions(): Promise<Jurisdiction[]> {
      return jurisdictionRepository.getJurisdictions({ host });
    }
  };
};

export default JurisdictionRepository;
